/* eslint-disable react/prefer-stateless-function */
/**
 * The HOC is used to get Main layout margins according to width and state of each sider.
 * @author: Ronan
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';

const mapStateToProps = ({ ui }) => ({
  siders: ui.siders,
});

const getContentMargins = WrappedComponent => connect(
  mapStateToProps,
)(class extends Component {
  render() {
    const { left, right, top, bottom } = this.props.siders;
    return (
      <WrappedComponent
        margins={{
          marginLeft: left,
          marginRight: right,
          marginTop: top,
          marginBottom: bottom,
        }}
        {...this.props}
      />
    );
  }
});

export default getContentMargins;



// WEBPACK FOOTER //
// ./src/components/hoc/getContentMargins.jsx